var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5403 13.7847L11.6882 10.0644L13.8361 6.34409C14.627 4.97432 14.1577 3.22279 12.7879 2.43195V2.43195C11.4181 1.6411 9.66657 2.11042 8.87573 3.4802L6.72781 7.20051",
    stroke: "#404B5A",
    strokeWidth: 0.937092
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92406 7.39241L8.31312 10.1826L6.3442 13.5929C5.94878 14.2778 6.18344 15.1536 6.86833 15.549V15.549C7.55322 15.9444 8.42898 15.7098 8.8244 15.0249L10.7933 11.6146",
    stroke: "#404B5A",
    strokeWidth: 0.937092,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15976 4.72042L4.5799 10.9209L3.1218 13.4464C1.94998 15.4761 2.64539 18.0714 4.67504 19.2432L4.76564 19.2955C6.79529 20.4673 9.39059 19.7719 10.5624 17.7423L14.8844 10.2564",
    stroke: "#404B5A",
    strokeWidth: 0.937092,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachIcon);
export default __webpack_public_path__ + "static/media/attach-icon.8d4e0fd47029ae2f8443ca1d0cc56c87.svg";
export { ForwardRef as ReactComponent };